/**
 * 活动管理
 */
export default {
  activityList: "/activityInfo/selectActivityInfoPage", // 活动列表
  activityListActivityClass: "/activityCategory/selectList", // 活动列表活动分类下拉框
  addActivity: "/activityInfo/insertActivityInfo", // 活动新增
  editActivityDetail: "/activityInfo/selectActivityInfoDetail", // 活动详情用于修改
  editActivity: "/activityInfo/updateActivityInfo", // 活动修改
  activityRegisterList: "/activityInfo/selectUserActivityPage", //报名详情列表
  activityRegisterListInfo: "/activityInfo/selectUserActivity", //报名详情列表查看详情
  deleteActivity: "/activityInfo/deleteActivityInfo", // 活动删除

  activityClassList: "/activityCategory/selectPage", // 活动分类列表
  addActivityClass: "/activityCategory/add", // 新增活动分类
  updateActivityClass: "/activityCategory/update", // 修改活动分类
  deleteActivityClass: "/activityCategory/delete", // 删除活动分类
}
